var _rect, _rect2, _rect3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppro({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "url(#paint0_linear_1605_12444)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "url(#paint1_linear_1605_12444)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "url(#paint2_linear_1605_12444)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1605_12444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7764 41.334C37.2124 42.929 35.6914 44 33.9954 44H24.0054C22.8354 44 21.7264 43.49 20.9614 42.602C20.2084 41.727 19.8744 40.577 20.0444 39.444C20.4494 36.746 21.9294 34.246 24.4454 32C21.9294 29.754 20.4494 27.254 20.0444 24.556C19.8744 23.424 20.2084 22.273 20.9614 21.399C21.7264 20.51 22.8354 20 24.0054 20H33.9954C35.6914 20 37.2124 21.071 37.7764 22.666C37.9614 23.187 37.6884 23.758 37.1684 23.942C36.6474 24.129 36.0764 23.854 35.8924 23.334C35.6094 22.536 34.8474 22 33.9964 22H24.0054C23.4184 22 22.8604 22.257 22.4774 22.703C22.0994 23.142 21.9384 23.694 22.0234 24.258C22.3984 26.757 23.9454 29.098 26.6214 31.216C26.8614 31.405 27.0014 31.695 27.0014 32C27.0014 32.305 26.8614 32.595 26.6214 32.784C23.9454 34.902 22.3984 37.242 22.0234 39.741C21.9384 40.305 22.0994 40.858 22.4774 41.297C22.8614 41.743 23.4184 42 24.0054 42H33.9954C34.8474 42 35.6084 41.464 35.8914 40.667C36.0764 40.146 36.6494 39.871 37.1674 40.059C37.6884 40.243 37.9604 40.815 37.7754 41.335L37.7764 41.334ZM29.6264 33.944L30.1344 34.349C31.3064 35.281 32.8614 36.78 33.6084 38.624C33.7334 38.933 33.6964 39.283 33.5104 39.559C33.3244 39.834 33.0144 40 32.6814 40H25.3194C24.9874 40 24.6764 39.834 24.4904 39.559C24.3044 39.284 24.2674 38.934 24.3914 38.626C25.1374 36.773 26.6914 35.28 27.8634 34.353L28.3834 33.942C28.7474 33.653 29.2624 33.654 29.6264 33.944ZM28.9994 36.004C28.3684 36.513 27.6284 37.198 27.0344 38H30.9624C30.3684 37.202 29.6304 36.516 28.9994 36.004ZM44.0004 32.001C44.0004 35.31 41.3094 38.001 38.0004 38.001C34.6914 38.001 32.0004 35.31 32.0004 32.001C32.0004 28.692 34.6914 26.001 38.0004 26.001C41.3094 26.001 44.0004 28.692 44.0004 32.001ZM42.0004 32.001C42.0004 29.795 40.2064 28.001 38.0004 28.001C35.7944 28.001 34.0004 29.795 34.0004 32.001C34.0004 34.207 35.7944 36.001 38.0004 36.001C40.2064 36.001 42.0004 34.207 42.0004 32.001ZM39.0004 31.587V30.001C39.0004 29.449 38.5534 29.001 38.0004 29.001C37.4474 29.001 37.0004 29.449 37.0004 30.001V32.001C37.0004 32.266 37.1054 32.521 37.2934 32.708L38.2934 33.708C38.4884 33.903 38.7444 34.001 39.0004 34.001C39.2564 34.001 39.5124 33.903 39.7074 33.708C40.0984 33.317 40.0984 32.685 39.7074 32.294L39.0004 31.587Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1605_12444",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63B967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BA64F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1605_12444",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#439DEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E78E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1605_12444",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3D45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1605_12444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppro);
export default __webpack_public_path__ + "static/media/appro.ab2fbc6566f47dca578352f9e1dbd569.svg";
export { ForwardRef as ReactComponent };